// export const FrontendURL = 'https://backend.sastraprakasika.imaginetventures.me/';
// export const BaseURL = 'https://app-spic-api-uat.vercel.app';

// -> Local
// export const FrontendURL = 'http://localhost:3000';
export const FrontendURL = 'https://frontend.sastraprakasika.imaginetventures.me';
// export const BaseURL = 'http://localhost:4500';
export const BaseURL = 'https://backend.sastraprakasika.imaginetventures.me';

const API_URL = `${BaseURL}/api/`;

const API = {
  Dashboard: API_URL + 'dashboard',
  Auth: {
    AuthSignIn: API_URL + 'users/login',
    GenerateOtp: API_URL + 'users/reset-email',
    VerifyOtp: API_URL + 'users/reset-email-verify',
    ResetPassword: API_URL + 'users/reset-pass',
  },
  Report: {
    PaymentReport: API_URL + 'payment/list',
  },
  Masters: {
    Category: API_URL + 'category/list',
    CategoryTerm: API_URL + 'category/term',
    CategoryAdd: API_URL + 'category/new',
    CategoryEdit: API_URL + 'category',
    CategoryDD: API_URL + 'category/dd',
    SubCategory: API_URL + 'category',
    Topic: API_URL + 'category/topic',

    LecturesAdd: API_URL + 'lectures/create',
    LecturesList: API_URL + 'lectures/list',
    LectureData: API_URL + 'lectures',
    LecturesUpdate: API_URL + 'lectures/lectures/update',
    Categories: API_URL + 'category',
    SubCategories: API_URL + 'subcategory',
    User: API_URL + 'users/list-users',
    UserById: API_URL + 'users/',
  },
};

export default API;
